export const DASH_STYLES = [
  '', // solid line
  '12, 4', // long dash, short gap
  '2, 2', // short dash, short gap
  '8, 4, 1, 4', // complex pattern
  '6, 6', // medium dash, medium gap
  '1, 3', // dot, medium gap
  '16, 4', // very long dash, short gap
  '10, 2, 4, 2', // complex pattern
  '3, 3, 6, 3', // complex pattern with medium elements
  '8, 4, 2, 4', // complex pattern
  '8, 2, 2, 2', // another complex pattern
  '4, 4', // medium-short dash, medium-short gap
  '1, 4', // dot, medium gap
];
export const DEFAULT_MARGINS = { top: 5, right: 0, bottom: 32, left: 0 };
